export const environment = {

  production: true,
  baseURL: '',
  apiToken: null
};
